import { render } from "./StandardPrintPage.vue?vue&type=template&id=7074fa25&scoped=true"
import script from "./StandardPrintPage.vue?vue&type=script&lang=js"
export * from "./StandardPrintPage.vue?vue&type=script&lang=js"

import "./StandardPrintPage.vue?vue&type=style&index=0&id=7074fa25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7074fa25"]])

export default __exports__